var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "父级ID", prop: "parentId" } },
        [
          _c("PermissionSelect", {
            attrs: { placeholder: "不选，默认为根目录" },
            model: {
              value: _vm.form.parentId,
              callback: function ($$v) {
                _vm.$set(_vm.form, "parentId", $$v)
              },
              expression: "form.parentId",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "启用", prop: "enabledFlag" } },
        [
          _c("BjRadioLov", {
            staticClass: "width-full",
            attrs: { "option-list": _vm.STATUS_YES_TRUE },
            model: {
              value: _vm.form.enabledFlag,
              callback: function ($$v) {
                _vm.$set(_vm.form, "enabledFlag", $$v)
              },
              expression: "form.enabledFlag",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "隐藏", prop: "hiddenFlag" } },
        [
          _c("BjRadioLov", {
            staticClass: "width-full",
            attrs: { "option-list": _vm.STATUS_YES_TRUE },
            model: {
              value: _vm.form.hiddenFlag,
              callback: function ($$v) {
                _vm.$set(_vm.form, "hiddenFlag", $$v)
              },
              expression: "form.hiddenFlag",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "标题", prop: "title" } },
        [
          _c("BjInput", {
            attrs: { placeholder: _vm.$t("inputText"), clearable: "" },
            model: {
              value: _vm.form.title,
              callback: function ($$v) {
                _vm.$set(_vm.form, "title", $$v)
              },
              expression: "form.title",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "编码", prop: "code" } },
        [
          _c("BjInput", {
            attrs: { placeholder: _vm.$t("inputText"), clearable: "" },
            model: {
              value: _vm.form.code,
              callback: function ($$v) {
                _vm.$set(_vm.form, "code", $$v)
              },
              expression: "form.code",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "icon", prop: "icon" } },
        [
          _c("BjInput", {
            attrs: { placeholder: _vm.$t("inputText"), clearable: "" },
            model: {
              value: _vm.form.icon,
              callback: function ($$v) {
                _vm.$set(_vm.form, "icon", $$v)
              },
              expression: "form.icon",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "排序", prop: "sort" } },
        [
          _c("BjInputNumber", {
            attrs: { clearable: "" },
            model: {
              value: _vm.form.sort,
              callback: function ($$v) {
                _vm.$set(_vm.form, "sort", $$v)
              },
              expression: "form.sort",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "权限类型", prop: "permissionType" } },
        [
          _c("BjRadioLov", {
            staticClass: "width-full",
            attrs: { "option-list": _vm.SETTING_PERMISSION_TYPE_LIST },
            model: {
              value: _vm.form.permissionType,
              callback: function ($$v) {
                _vm.$set(_vm.form, "permissionType", $$v)
              },
              expression: "form.permissionType",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }